<!-- <h1 mat-dialog-title class="text-center">
  El comercio se encuentra cerrado 😢
</h1>
<div class="text-center" mat-dialog-content>
  El comercio no está recibiendo pedidos en este momento, puedes ver la oferta, pero no podrás ordenar aún
</div>
<div class="w-100 text-center mb-3">
  <forrest-btn mat-dialog-close cdkFocusInitial [title]="'Ver oferta'"
    [color]="'btn-dark'"></forrest-btn>
</div> -->

<div class="p-5">
  <h3 class="text-center mb-3 title">
    {{'INFO_BUSINESS.CLOSED_TITLE' | translate}}
  </h3>
  <p class="text-center mb-4 content">
    {{'INFO_BUSINESS.CLOSED_DESCRIPTION' | translate}}
  </p>
  <div class="text-center">
    <forrest-btn [btnFullWidth]="false" size="xxl" mat-dialog-close cdkFocusInitial [title]="('INFO_BUSINESS.SEE_OFER' | translate)"
      [color]="'btn-dark'"></forrest-btn>
  </div>
</div>
